var _rect, _rect2, _rect3, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadReceipt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.2522,
    height: 5.0087,
    transform: "matrix(-1 0 0 1 24.3525 1.66943)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 17.2522,
    height: 5.0087,
    transform: "matrix(-1 0 0 1 19.8994 17.252)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 15.0261,
    height: 17.2522,
    transform: "matrix(-1 0 0 1 21.0137 5.00879)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15192 15.6522V3.13043C5.15192 1.40139 6.55331 0 8.28235 0H22.891C24.6201 0 26.0215 1.40139 26.0215 3.13043V8.34783H21.8476V20.8696C21.8476 22.5986 20.4462 24 18.7171 24H4.10844C2.37939 24 0.978004 22.5986 0.978004 20.8696V15.6522H5.15192ZM21.8476 6.26087H23.9345V3.13043C23.9345 2.55548 23.466 2.08696 22.891 2.08696C22.315 2.08696 21.8476 2.55443 21.8476 3.13043V6.26087ZM19.7606 20.8696V3.13043C19.7606 2.76522 19.8232 2.41357 19.939 2.08696H8.28235C7.7074 2.08696 7.23887 2.55548 7.23887 3.13043V15.6522H17.6737V20.8696C17.6737 21.4456 18.1411 21.913 18.7171 21.913C19.2921 21.913 19.7606 21.4445 19.7606 20.8696ZM3.06496 20.8696C3.06496 21.4445 3.53348 21.913 4.10844 21.913H15.7651C15.6493 21.5864 15.5867 21.2348 15.5867 20.8696V17.7391H3.06496V20.8696ZM9.32583 8.34783H17.6737V6.26087H9.32583V8.34783ZM9.32583 12.5217H17.6737V10.4348H9.32583V12.5217Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadReceipt);
export default __webpack_public_path__ + "static/media/download-receipt.00f7dea97679b9c0471b1ee6c8eca53e.svg";
export { ForwardRef as ReactComponent };